import { IconToast, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { createDataTable } from 'components/DataTable';
import { FeatureTable } from 'components/Features/FeatureTable';
import React, { useState } from 'react';
import { getFeatureDefinitions } from 'services/featureDefinition';
import { FeatureToggleWithDefinitionDTO, getProfileFeatures, postFeature } from 'services/featureToggle';
import { BygrProfileDetails, SortDirection } from 'types';
import { useAsyncStateWithIsLoading } from 'utils/hooks';

export interface ProfileFeaturesProps {
    profile: BygrProfileDetails;
    reloadProfile(): void;
}

const DataTable = createDataTable<FeatureToggleWithDefinitionDTO>();

export const ProfileFeatures: React.FC<ProfileFeaturesProps> = ({ profile }) => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('featureName', SortDirection.Ascending, 20));
    const [profileFeatures, , reload] = useAsyncStateWithIsLoading(
        () => getProfileFeatures({ ...tableState, profileId: profile.id }),
        [],
        null
    );
    const [featureDefinitions] = useAsyncStateWithIsLoading(getFeatureDefinitions, [], null);
    const [isSaving, setIsSaving] = useState(false);
    if (!profileFeatures || !featureDefinitions) return <LoadingIndicator />;

    const handleFeatureToggle = async (checked: boolean, feature: string) => {
        setIsSaving(true);
        try {
            await postFeature({
                featureName: feature,
                profileId: profile.id,
                toggled: checked,
            });
            reload();
            IconToast.success('Feature toggled');
        } catch (e) {
            IconToast.warning('Something went wrong :( ');
            console.log(e);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <FeatureTable
            data={profileFeatures.items}
            handleFeatureToggle={handleFeatureToggle}
            setTableState={setTableState}
            tableState={tableState}
        />
    );
};
